export const DRAFT_TAB_PREFIX = 'draft:';

export const isDraftTabId = (id: string): boolean =>
  id.startsWith(DRAFT_TAB_PREFIX);

export const createDraftTabId = (): string =>
  `${DRAFT_TAB_PREFIX}${crypto.randomUUID()}`;

/**
 * New with no open tabs is the blank slate. New with tabs already open uses
 * one draft tab so a second New does not stack empty "New chat" tabs.
 */
export const nextTabsForNewChat = (
  openTabIds: string[],
): { openTabIds: string[]; activeTabId: string | null } => {
  if (openTabIds.length === 0) {
    return { openTabIds, activeTabId: null };
  }

  const existing = openTabIds.find(isDraftTabId);
  if (existing) {
    return { openTabIds, activeTabId: existing };
  }

  const draftId = createDraftTabId();
  return { openTabIds: [...openTabIds, draftId], activeTabId: draftId };
};
